module.exports = __webpack_public_path__ + "static/img/3-cisco.4b548bdb.png";